RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.HandlePicker = Marionette.CompositeView.extend({
        template: '#adminCompanyHandlePickerTemplate',

        childViewContainer: '.x-seen-list',
        childView: views.HandlePickerItem,

        childViewOptions: function () {
            const me = this;

            return {
                handles: me.model
            };
        },

        childEvents: {
            'add:handle': 'render'
        },

        modelEvents: {
            'add': 'closeModal'
        },

        closeModal: function () {
            App.handleDiscoveryModal.$el.modal('hide');
        }
    });
});
